import { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";

const SMOOTH = "cubic-bezier(0.4, 0, 0.2, 1)";

const Textarea = ({
  label,
  value,
  onChange,
  icon,
  accent = "#04aec1",
  rows = 5,
}) => {
  const [focus, setFocus] = useState(false);
  const filled = !!value;
  const isFloating = focus || filled;
  const iconLeft = icon ? "38px" : "14px";

  return (
    <Box position="relative">
      <Box
        position="relative"
        bg={focus ? "#ffffff" : "rgba(255,255,255,0.85)"}
        border="1px solid"
        borderColor={focus ? accent : "rgba(15,22,38,0.10)"}
        borderRadius="12px"
        transition={`border-color .2s ${SMOOTH}, background .2s ${SMOOTH}, box-shadow .2s ${SMOOTH}`}
        boxShadow={
          focus
            ? `0 0 0 4px ${accent}22, 0 8px 22px -10px ${accent}55`
            : "none"
        }
      >
        {icon && (
          <Flex
            position="absolute"
            left="14px"
            top="20px"
            color={focus ? accent : "rgba(15,22,38,0.55)"}
            fontSize="14px"
            transition={`color .2s ${SMOOTH}`}
            pointerEvents="none"
          >
            {icon}
          </Flex>
        )}

        <Box
          as="label"
          position="absolute"
          left={iconLeft}
          top={isFloating ? "6px" : "20px"}
          fontSize={isFloating ? "10px" : "13px"}
          fontWeight={isFloating ? 600 : 500}
          letterSpacing={isFloating ? "0.08em" : 0}
          textTransform={isFloating ? "uppercase" : "none"}
          color={focus ? accent : "rgba(15,22,38,0.55)"}
          transition={`all .2s ${SMOOTH}`}
          pointerEvents="none"
        >
          {label}
        </Box>

        <Box
          as="textarea"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          rows={rows}
          width="100%"
          background="transparent"
          border="none"
          outline="none"
          fontSize="14px"
          fontWeight={500}
          fontFamily="inherit"
          color="#0a0e1a"
          padding={`${isFloating ? "22px" : "18px"} 14px 14px ${
            icon ? "38px" : "14px"
          }`}
          resize="vertical"
          sx={{ caretColor: accent, minHeight: `${rows * 22}px` }}
        />
      </Box>
    </Box>
  );
};

export default Textarea;
